import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Table, Thead, Tbody, Tr, Th, Td } from "@material-tailwind/react";
import { useMutation } from "react-query";
import moment from "moment-timezone";
import { XMarkIcon } from "@heroicons/react/20/solid";
import http, { httpPostProcessing } from "../../../services/http-common";
import { setSessionExpired, useMainController } from "../../../context";
import { toast } from "react-toastify";

function ViewLogsDoc(props) {
  const [dispatch] = useMainController();
  const { open, toogleOpenEditor, id, docType } = props;
  const [allLogs, setAllLogs] = useState(null);
  const [loading, setLoading] = useState(false);

  const errorFunc = (error) => {
    let message;
    message = error.response.data.message || error.message;
    toast.error(message);
  };

  const toogleOpen = () => {
    if (loading) return false;
    if (open) {
      setAllLogs(null);
    }
    toogleOpenEditor();
  };

  const getDocLogs = useMutation(
    (docId) => {
      return http.get(
        docType === "scientific"
          ? `train/book/find-logs/${docId}`
          : `law-docs/find-logs/${docId}`,
        null,
        setSessionExpired,
        dispatch
      );
    },
    {
      onSuccess: ({ data }) => {
        setAllLogs(data.docs);
      },
      onError: (error) => {
        errorFunc(error);
      },
      onSettled: () => {
        setLoading(false);
      },
      onMutate: () => {
        setLoading(true);
      },
    }
  );
  const getWisdomDocLogs = useMutation(
    (docId) => {
      return httpPostProcessing.get(
        `wisdom-docs/find-logs/${docId}`,
        null,
        setSessionExpired,
        dispatch
      );
    },
    {
      onSuccess: ({ data }) => {
        setAllLogs(data.docs);
      },
      onError: (error) => {
        errorFunc(error);
      },
      onSettled: () => {
        setLoading(false);
      },
      onMutate: () => {
        setLoading(true);
      },
    }
  );

  const getDocLogsFunc = () => {
    if (id === null) return false;
    docType === "wisdom" ? getWisdomDocLogs.mutate(id) : getDocLogs.mutate(id);
  };

  useEffect(() => {
    getDocLogsFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"md"}
      onClose={toogleOpen}
      scroll={"paper"}
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.9, y: -100 },
      }}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        className="flex justify-between items-center "
      >
        <div className="w-full justify-start items-center">
          <span className="font-bold ">Document Logs</span>
        </div>
        <span className="cursor-pointer" onClick={toogleOpen}>
          <XMarkIcon className="w-7" />
        </span>
      </DialogTitle>
      <DialogContent dividers={true}>
        {allLogs ? (
          <div className="p-4">
            <div className="overflow-x-auto">
              <Table className="min-w-full table-auto border-collapse border border-gray-200">
                <Thead>
                  <Tr className="bg-gray-100">
                    <Th className="border border-gray-300 px-4 py-2">Time</Th>
                    <Th
                      className="border border-gray-300 px-4 py-2"
                      data-priority="1"
                    >
                      Logs
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {allLogs.map((doc) => (
                    <Tr key={doc.id} className="hover:bg-gray-50">
                      <Th className="border border-gray-300 px-4 py-2">
                        {moment(doc.updated_at, "YYYYMMDD").fromNow()}
                      </Th>
                      <Td className="border border-gray-300 px-4 py-2">
                        {doc.log}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </div>
          </div>
        ) : (
          "Loading..."
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ViewLogsDoc;
